<form [formGroup]="dataForm" class="without-default-focus">
    <!-- Date de reference -->
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Référence</mat-label>
            <mat-select formControlName="reference" required tabindex="10" (selectionChange)="onReferenceChanged($event)">
                @for (reference of DateReferencesList; track reference.value) {
                    <mat-option [value]="reference.value">
                        {{ reference.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['reference']?.required && (dataForm.controls['reference']?.dirty || dataForm.controls['reference'].touched)) {
                <mat-error>Le champ 'Reference' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Reference" matTooltipPosition="right"></fa-icon>
    </div>

    <!-- Attribut contenant la date de reference -->
    @if (selectedReference === DateReferences.DateAttribute) {
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Attribut date</mat-label>
                <mat-select formControlName="dateAttribute" required tabindex="1">
                    <mat-option *ngFor="let attribute of _dateAttributes" [value]="attribute.id">
                        {{ attribute.header }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="dataForm.controls['dateAttribute']?.errors?.required && (dataForm.controls['dateAttribute']?.dirty || dataForm.controls['dateAttribute'].touched)">
                    Le champ 'Attribut' est obligatoire
                </mat-error>
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO attribute" matTooltipPosition="right"></fa-icon>
        </div>
    }

    <!-- Etape à partir de laquelle est définie la date de reference -->
    @if (selectedReference === DateReferences.WorkflowStepStart || selectedReference === DateReferences.WorkflowStateStart) {
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Etape</mat-label>
                <mat-select formControlName="step" required tabindex="10" (selectionChange)="onStepChanged($event)">
                    @for (item of _steps; track item.id) {
                        <mat-option [value]="item.id">
                            {{ item.data.stepName }}
                        </mat-option>
                    }
                </mat-select>
                @if (dataForm.errors && dataForm.errors['step']?.required && (dataForm.controls['step']?.dirty || dataForm.controls['step'].touched)) {
                    <mat-error>Le champ 'Etape' est obligatoire</mat-error>
                }
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etape" matTooltipPosition="right"></fa-icon>
        </div>
    }

    @if (selectedReference === DateReferences.WorkflowStateStart) {
        <!-- Etat à partir duquel est défini la date de reference -->
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Etat</mat-label>
                <mat-select formControlName="state" required tabindex="10">
                    @for (item of states; track item) {
                        <mat-option [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    }
                </mat-select>
                @if (dataForm.errors && dataForm.errors['state']?.required && (dataForm.controls['state']?.dirty || dataForm.controls['state'].touched)) {
                    <mat-error>Le champ 'État' est obligatoire</mat-error>
                }
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
        </div>
    }

    <!-- Type de délai -->
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Type de délai</mat-label>
            <mat-select formControlName="delayType" required tabindex="10" (selectionChange)="onDelayTypeChanged($event)">
                @for (delayType of DelayTypesList; track delayType.value) {
                    <mat-option
                        [value]="delayType.value"
                        [disabled]="delayType.value === DelayTypes.WorkflowStepMaxDuration && !(selectedReference === DateReferences.WorkflowStepStart)">
                        {{ delayType.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['delayType']?.required && (dataForm.controls['delayType']?.dirty || dataForm.controls['delayType'].touched)) {
                <mat-error>Le champ 'Type de délai' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO delayType" matTooltipPosition="right"></fa-icon>
    </div>

    @if (selectedDelayType === DelayTypes.AttributeValue) {
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Attribut délai</mat-label>
                <mat-select formControlName="delayAttribute" required tabindex="1">
                    <mat-option *ngFor="let attribute of _intAttributes" [value]="attribute.id">
                        {{ attribute.header }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="dataForm.controls['delayAttribute']?.errors?.required && (dataForm.controls['delayAttribute']?.dirty || dataForm.controls['delayAttribute'].touched)">
                    Le champ 'Attribut' est obligatoire
                </mat-error>
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO delayAttribute" matTooltipPosition="right"></fa-icon>
        </div>
    }

    @if (selectedDelayType === DelayTypes.FixedValue) {
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Délai</mat-label>
                <input matInput type="text" formControlName="delay" autocomplete="off" required tabindex="11" />
                @if (dataForm.errors && dataForm.errors['delay']?.required && (dataForm.controls['delay']?.dirty || dataForm.controls['delay'].touched)) {
                    <mat-error>Le champ 'Délai' est obligatoire</mat-error>
                }
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Delai" matTooltipPosition="right"></fa-icon>
        </div>
    }

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Unité</mat-label>
            <mat-select formControlName="unit" required tabindex="12">
                @for (timeUnit of TimeUnitsList; track timeUnit.value) {
                    <mat-option [value]="timeUnit.value">
                        {{ timeUnit.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['unit']?.required && (dataForm.controls['unit']?.dirty || dataForm.controls['unit'].touched)) {
                <mat-error>Le champ 'Unité' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Unité" matTooltipPosition="right"></fa-icon>
    </div>
</form>
